<template>
  <div id="app" v-bind:class="{langEN : $store.getters.language}">
    <link href="https://fonts.googleapis.com/css?family=Open+Sans&display=swap" rel="stylesheet">
    <div class="homepage">
      <navigation />
      <transition
              name="fade"
              mode="out-in"
              @beforeLeave="beforeLeave"
              @enter="enter"
              @afterEnter="afterEnter"
      >
        <router-view />
      </transition>
      <footer-item />
    </div>
  </div>
</template>

<script>
import Navigation from './components/navigation/navigation'
import FooterItem from './components/footer/footer'
import '@/assets/css/tailwind.css'


export default {
  name: 'app',
  components: {
      Navigation,
      FooterItem
  },
  data(){
      return{
          prevHeight: 0
      }
    },
    created: function(){
        if(localStorage.getItem('language') === null) {
            var lang = navigator.language;
            console.log(lang);
            if (!~lang.indexOf('de')) {
                console.log('de_DE');
                this.$store.commit('language', true);
            }
        }
    },
  methods: {
      beforeLeave(element) {
        this.prevHeight = getComputedStyle(element).height;
      },
      enter(element) {
        const { height } = getComputedStyle(element);

        element.style.height = this.prevHeight;

        setTimeout(() => {
          element.style.height = height;
        });
      },
      afterEnter(element) {
        element.style.height = 'auto';
      },

    }
}
</script>

<style lang="scss">
  html, body, html *, body *, * {
    font-family: 'Open Sans', sans-serif;
  }
  html, body{
    max-width: 100vw;
    overflow-x: hidden;
  }
  .lang-en{
    display: none;
    .langEN &{
      display: block;
    }
  }
  .lang-de{
    .langEN &{
      display: none;
    }
  }
  .fade-enter-active,
  .fade-leave-active {
    transition-duration: 0.3s;
    transition-property: opacity;
    transition-timing-function: ease;
  }

  .fade-enter,
  .fade-leave-active {
    opacity: 0
  }
</style>
